import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { GButtonBox, GPopupTitle } from 'components/layouts/GLayoutBox';
import { DialogTitleItem } from 'components/layouts/GModalPopup';
import { GButton } from 'components/atom/button';
import ModalLayout from 'components/layouts/ModalLayout';
import styled from '@emotion/styled';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import GuidemanualContent from 'components/vars/login/GuideManual';
import useSessionStore from 'stores/useSessionStore';

type GuideManualModalProps = {
  open: boolean;
  close: () => void;
  save: () => void;
};

const GuideManualModal = (props: GuideManualModalProps) => {
  // 'ko', 'en', 'zhC'
  const { t } = useTranslation();
  const { langCd } = useSessionStore();

  const handleClose = () => {
    props.close();
  };

  return (
    <>
      <ModalLayout open={props.open} onClose={handleClose} mMinWidth={300} mMaxWidth={600}>
        <DialogTitleItem onClose={handleClose}>
          <GPopupTitle title2={t('com.label.00006', '__안내매뉴얼')} />
        </DialogTitleItem>
        <DialogContent className="popupContent">
          <AreaAlignWrap>
            <GuidemanualContent />
          </AreaAlignWrap>
        </DialogContent>
        <DialogActions className="popupBottom">
          <GButtonBox>
            {/* <GButton
              txt={t('com.label.00036', '취소')}
              sizes="medium"
              onClick={handleClose}
              btnColor="normal"
              btnstyled="outline"
              hasImg={false}
              hasTxt={true}
            /> */}
          </GButtonBox>
        </DialogActions>
      </ModalLayout>
    </>
  );
};

const AreaAlignWrap = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;
`;

export default GuideManualModal;
